"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormGroup = void 0;
const react_1 = require("react");
const FormGroup_1 = require("../components/FormGroup");
function useFormGroup() {
    return react_1.useContext(FormGroup_1.FormGroupContext);
}
exports.useFormGroup = useFormGroup;
//# sourceMappingURL=useFormGroup.js.map